var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import BrowserLogger from 'alife-logger';
import { getGlobalParams } from '@funny/env';
var isProduction = process.env.NODE_ENV === 'production';
var emptyFunction = function () { };
var defaultConfig = {
    pid: 'fgw29hkkce@a8e8dceb20f33ee',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    useFmp: true,
    enableSPA: true,
    parseHash: function (hash) {
        var page = hash ? hash.replace(/^#/, '').replace(/\?.*$/, '') : '';
        return page || location.pathname;
    },
    ignore: {
        ignoreErrors: [/setShareUrlParams/, /__changbaPageHideCallback/, /^Script error\.?$/],
    },
    environment: isProduction ? 'prod' : 'local',
};
var LoggerMonitor = /** @class */ (function () {
    function LoggerMonitor() {
        var _this = this;
        /**
         * 函数队列，在没有初始化全局参数的时候，都将记录到任务队列里面去
         */
        this.loggerCallQueue = [];
        this.initialized = false;
        getGlobalParams().then(function (globalParams) {
            _this.globalParams = globalParams;
            _this.initialized = true;
            _this.flushLoggerCallQueue();
        });
    }
    /**
     * 清理调用队列
     */
    LoggerMonitor.prototype.flushLoggerCallQueue = function () {
        while (this.loggerCallQueue.length) {
            var fn = this.loggerCallQueue.shift();
            fn.apply(this);
        }
    };
    /**
     * 初始化浏览器监控
     */
    LoggerMonitor.prototype.initializeBrowserLogger = function (_a, options) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.projectName, projectName = _c === void 0 ? document.title : _c, _d = _b.developmentDisabled, developmentDisabled = _d === void 0 ? true : _d;
        if (options === void 0) { options = {}; }
        if (!this.initialized) {
            this.loggerCallQueue.push(function () {
                _this.initializeBrowserLogger({
                    projectName: projectName,
                    developmentDisabled: developmentDisabled,
                }, options);
            });
            return;
        }
        if (!isProduction && developmentDisabled) {
            return {
                setConfig: emptyFunction,
                api: emptyFunction,
                error: emptyFunction,
                speed: emptyFunction,
                sum: emptyFunction,
                avg: emptyFunction,
                resource: emptyFunction,
                event: emptyFunction,
                setPage: emptyFunction,
                setCommonInfo: emptyFunction,
                custom: emptyFunction,
            };
        }
        var _e = this.globalParams, userId = _e.userId, appVersion = _e.appVersion;
        var config = __assign(__assign(__assign({}, defaultConfig), { uid: userId, c1: appVersion, release: appVersion, tag: projectName }), options);
        return BrowserLogger.singleton(config);
    };
    return LoggerMonitor;
}());
var monitor = new LoggerMonitor();
// 对外暴露方法
export var init = monitor.initializeBrowserLogger.bind(monitor);
